import { render } from "./ConfirmPasswordReset.vue?vue&type=template&id=5803357e"
import script from "./ConfirmPasswordReset.vue?vue&type=script&lang=js"
export * from "./ConfirmPasswordReset.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/onlyfoodies-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__